import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Box, useMediaQuery } from '@mui/material';
import useStyles from './FFHeroBanner.styles';
import { useBackgroundClass } from '../../styles/jss/utils';
import GenericImage from '../GenericImage/GenericImage';
import Content from '../Content/Content';
import { getContentPositionClass, getMinHeightClass } from '../../utils/common';
import useCommonStyles from '../../styles/jss/common';
const FFHeroBanner = (props) => {
    var _a;
    const { headingColor = 'COBALT', contentPosition = 'LEFT', minHeight = 'MEDIUM', isFullWidthImage = false, headingTag = 'H3', image, darknessLevel, links, subheading, buttonVariant, backgroundColor, } = props;
    const { classes } = useStyles({ linksCount: (_a = links === null || links === void 0 ? void 0 : links.length) !== null && _a !== void 0 ? _a : 0, contentPosition, isFullWidthImage });
    const { classes: commonClasses } = useCommonStyles({});
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const heading = typeof props.heading === 'string' && props.heading.trim()
        ? props.heading.split('/').map((line, index) => (_jsx("span", { className: clsx(classes.headingLine, headingColor && classes[headingColor], contentPosition === 'CENTER' ? classes.centerHeading : ''), children: line.trim() }, index)))
        : props.heading;
    const { bgClass, rgbColor } = useBackgroundClass(backgroundColor);
    const contentPositionClass = getContentPositionClass(contentPosition, {
        positionLeft: classes.positionLeft,
        positionCenter: classes.positionCenter,
        positionRight: classes.positionRight,
    });
    const minHeightClass = {
        minHeightSmall: commonClasses.minHeightSmall,
        minHeightMedium: commonClasses.minHeightMedium,
        minHeightLarge: commonClasses.minHeightLarge,
    };
    let imageClassNames = [];
    if (isMobile) {
        imageClassNames = [classes.mobileImage];
    }
    else if (!isFullWidthImage) {
        imageClassNames = [classes.squareImage];
    }
    else {
        imageClassNames = [classes.imageFit];
    }
    return (_jsxs(Box, { className: clsx(classes.container, bgClass, contentPositionClass, getMinHeightClass(minHeight, minHeightClass), isMobile && classes.ffMobileheight), children: [_jsx(GenericImage, Object.assign({}, props, { image: image, darknessLevel: darknessLevel, isPriority: true, renderSquaredImagesOptions: isFullWidthImage, showImageSpacer: true, fullWidthImage: true, minHeight: minHeight, addBackgroundColorForImage: true, backgroundColor: rgbColor, classNames: imageClassNames })), _jsx(Content, Object.assign({}, props, { heading: heading, subheading: subheading, subheadingClasses: [classes.subheading], containerClasses: [classes.content], linkContainerClasses: [classes.linkContainerClass], linkClassNames: [classes.linkClass], contentInnerClasses: contentPosition === 'CENTER' ? [classes.ffCenterContentInner] : [], buttonVariant: buttonVariant, messageClasses: [classes.message], headingClasses: [classes.heading], headingTag: headingTag, linkStyle: "BUTTON", links: links }))] }));
};
export default FFHeroBanner;
